export enum ResourceBarMode {
	CHARGE_UP_SHOT = 0,
	ENERGY_COST_SHOT = 1,
}
